/* eslint import/no-cycle: 0 */

import View from './Provider-view';

export default View;
